<template>
  <div class="collectionDetailVideo"
    :style="pageSetting">
    <button type="button" class="btnClose" @click.stop="close"></button>
    <div class="frame">
      <div v-if="breadCrumb && breadCrumb.length" class="name" :style="nameSpacing">
        <span v-for="path in breadCrumb"
          :key="path.categoryId"
          class="path">
          {{ path.categoryLabel[lang] }}
        </span>
        {{ detailItem.collectionItemName[lang] }}
      </div>
      <iframe :src="detailItem.embed" frameborder="0"></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DetailVideo',
  props: [
    'locale',
    'lang',
    'pageId',
    'categoryId',
  ],
  components: {
  },
  computed: {
    isDirect () {
      return !this.$route.params.collectionItemId
    },
    collectionSetting () {
      return this.$store.getters['collection/getCollectionSetting']
    },
    pageSetting () {
      const setting = this.collectionSetting
      const itemDetail = this.itemInfo && this.itemInfo.attribute
      return  {
        backgroundColor: itemDetail && itemDetail.detailColorActive ? itemDetail.detailBackgroundColor : setting.backgroundColor,
        color: itemDetail && itemDetail.detailColorActive ? itemDetail.detailTextColor : ''
      }
    },
    itemInfo () {
      const collectionItemId = this.$store.getters['collection/getDetailVideo']
      return collectionItemId && this.$store.getters['collection/getItemByItemId'](collectionItemId)
    },
    detailItem () {
      const collectionItem = this.itemInfo
      const collectionCategory = collectionItem && this.$store.getters['collection/getCategoryById'](collectionItem.categoryIds[0])
      function convertEmbed(link) {
        const match = link.match(/youtu\.be\/([a-zA-Z0-9_-]+)/)
        if (match && match[1]) {
          return `https://www.youtube.com/embed/${match[1]}`
        }
        return null
      }
      return collectionItem && {
        collectionItemName: collectionItem.collectionItemName,
        categoryName: collectionCategory && collectionCategory.categoryLabel,
        embed: convertEmbed(collectionItem.attribute.embed)
      }
    },
    breadCrumb () {
      const getCategoryListAll = this.$store.getters['collection/getCategoryListAll']
      function getBreadcrumbById (categoryId, categoryList) {
        const path = []
        function findPath(categories, targetId, currentPath) {
          for (const category of categories) {
            const newPath = [...currentPath, {
              categoryId: category.categoryId,
              categoryLabel: category.categoryLabel,
              routeName: category.useMain ? 'collectionCategoryMain' : 'collectionPage'
            }]

            if (category.categoryId === targetId) {
              path.push(...newPath)
              return true
            }

            if (category.subCategory && category.subCategory.length) {
              const found = findPath(category.subCategory, targetId, newPath)
              if (found) return true
            }
          }
          return false
        }

        findPath(categoryList, categoryId, [])
        return path
      }
      return getCategoryListAll && getBreadcrumbById(this.categoryId, getCategoryListAll)
    },
    nameSpacing () {
      const spacing = this.$store.getters['collection/getCommonItemStyle']
      return spacing && spacing.name && {
        letterSpacing: spacing.name
      }
    },
  },
  mounted () {
  },
  data() {
    return {
    }
  },
  methods: {
    close () {
      this.$store.commit('collection/setDetailVideo', null)
    }
  }
}
</script>
